import { render } from "./ItemInfoContainer.vue?vue&type=template&id=8a2911c0&scoped=true"
import script from "./ItemInfoContainer.vue?vue&type=script&lang=js"
export * from "./ItemInfoContainer.vue?vue&type=script&lang=js"

import "./ItemInfoContainer.vue?vue&type=style&index=0&id=8a2911c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2911c0"],['__file',"src/components/ItemInfoContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a2911c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a2911c0', __exports__)) {
    console.log('reload')
    api.reload('8a2911c0', __exports__)
  }
  
  module.hot.accept("./ItemInfoContainer.vue?vue&type=template&id=8a2911c0&scoped=true", () => {
    console.log('re-render')
    api.rerender('8a2911c0', render)
  })

}


export default __exports__